import React, { useState } from 'react';
import office from '../../../assets/images/main-slider/students.png';
import AdmissionCriteria from './AdmissionCriteria';
import MscAdmission from './MscAdmission';
import DistanceCriteria from './DistanceCriteria';
import CTASection from '../CTASection';

const Overview = () => {
  const [fullPage, setFullPage] = useState(false);
  const [currentCriteria, setCurrentCriteria] = useState(null);

  const toggleAdmissionCriteria = () => {
    setFullPage(!fullPage);
    setCurrentCriteria(fullPage ? null : 'undergraduate');
  };

  const toggleMscAdmissionCriteria = () => {
    setFullPage(!fullPage);
    setCurrentCriteria(fullPage ? null : 'graduate');
  };

  const toggleDistanceAdmissionCriteria = () => {
    setFullPage(!fullPage);
    setCurrentCriteria(fullPage ? null : 'distance');
  };

  const toggleTVETAdmissionCriteria = () => {
    setFullPage(!fullPage);
    setCurrentCriteria(fullPage ? null : 'tvet');
  };

  const renderCriteriaContent = () => {
    switch (currentCriteria) {
      case 'undergraduate':
        return <AdmissionCriteria />;
      case 'graduate':
        return <MscAdmission />;
      case 'distance':
        return <DistanceCriteria />;
      case 'tvet':
        return <DistanceCriteria />;
      default:
        return null;
    }
  };

  return (
    <div className={fullPage ? 'full-page' : ''}>
      <div className="banner-slide">
        <img src={office} alt="Banner 2" className="banner-image" />
        <div className="banner-content">
          <h2>ADMISSION</h2>
          <p>
            Join Admas University — one of Ethiopia’s leading higher education institutions. <br />
            Apply now for undergraduate & postgraduate programs that shape your future. <br />
            Quality education, expert faculty, and a supportive learning environment await you.
          </p>
        </div>
      </div>

      {!fullPage && (
        <section className="projects-details">
          <h4 style={{ marginBottom: '30px', marginLeft: '20px' }}>OVERVIEW</h4>
          <div className="auto-container">
            <div className="text-block">
              <div className="row">
                <div className="col-lg-10">
                  <div className="text">
                    <p>
                      The Admissions Office at Admas University is dedicated to guiding prospective students through a seamless application process. Our mission is to provide high-quality education and foster academic excellence, empowering students to achieve their educational goals in a supportive environment.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-block">
              <div className="row">
                <div className="col-lg-10">
                  <div className="sec-title style-two">
                    <h4>TYPES OF ADMISSIONS</h4>
                  </div>
                  <div>
                    <ul className="services-list">
                      <li>
                        <div className="icon-box">
                          <span className="flaticon-book" style={{ marginRight: '20px', color: '#1ab5f1', fontWeight: 'bolder', fontSize: '1.5em' }}></span>
                          Undergraduate Admissions:
                          <button
                            onClick={toggleAdmissionCriteria}
                            style={{
                              backgroundColor: 'rgb(49, 168, 219)',
                              color: 'white',
                              borderRadius: '20px',
                              padding: '5px 10px',
                              marginLeft: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            SHOW ADMISSION CRITERIA
                          </button>
                        </div>
                      </li>
                      <li>
                        <div className="icon-box">
                          <span className="flaticon-book" style={{ marginRight: '20px', color: '#1ab5f1', fontWeight: 'bolder', fontSize: '1.5em' }}></span>
                          Graduate Admissions:
                          <button
                            onClick={toggleMscAdmissionCriteria}
                            style={{
                              backgroundColor: 'rgb(49, 168, 219)',
                              color: 'white',
                              borderRadius: '20px',
                              padding: '5px 10px',
                              marginLeft: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            SHOW ADMISSION CRITERIA
                          </button>
                        </div>
                      </li>
                      <li>
                        <div className="icon-box">
                          <span className="flaticon-book" style={{ marginRight: '20px', color: '#1ab5f1', fontWeight: 'bolder', fontSize: '1.5em' }}></span>
                          Distance Education Admissions:
                          <button
                            onClick={toggleDistanceAdmissionCriteria}
                            style={{
                              backgroundColor: 'rgb(49, 168, 219)',
                              color: 'white',
                              borderRadius: '20px',
                              padding: '5px 10px',
                              marginLeft: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            SHOW ADMISSION CRITERIA
                          </button>
                        </div>
                      </li>
                      <li>
                        <div className="icon-box">
                          <span className="flaticon-book" style={{ marginRight: '20px', color: '#1ab5f1', fontWeight: 'bolder', fontSize: '1.5em' }}></span>
                          Technical and Vocational Education and Training:
                          <button
                            onClick={toggleTVETAdmissionCriteria}
                            style={{
                              backgroundColor: 'rgb(49, 168, 219)',
                              color: 'white',
                              borderRadius: '20px',
                              padding: '5px 10px',
                              marginLeft: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            SHOW ADMISSION CRITERIA
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {fullPage && (
        <div className="full-page-content">
          <button
            onClick={() => setFullPage(false)}
            style={{
              backgroundColor: 'rgb(49, 168, 219)',
              color: 'white',
              borderRadius: '20px',
              padding: '10px 20px',
              cursor: 'pointer',
              margin: '20px',
            }}
          >
            Back to Overview
          </button>
          {renderCriteriaContent()}
        </div>
      )}

      <CTASection />
    </div>
  );
};

export default Overview;